// app/contact/ContactForm.tsx

"use client";

import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Send } from "lucide-react";

export default function ContactForm() {
  const [result, setResult] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
  event.preventDefault();

  const form = event.currentTarget; // 👈 ذخیره‌ی امن
  setIsSubmitting(true);

  const formData = new FormData(form);
  const formObject = Object.fromEntries(formData.entries());

  formObject.access_key =
    process.env.NEXT_PUBLIC_WEB3FORMS_ACCESS_KEY!;

  try {
    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(formObject),
    });

    const json = await response.json();

    if (json.success) {
      setResult("Message sent successfully!");
      form.reset(); // ✅ همیشه معتبر
    } else {
      setResult(json.message || "Something went wrong.");
    }
  } catch (error) {
    console.error(error);
    setResult("An error occurred while sending the message.");
  } finally {
    setIsSubmitting(false);
    setTimeout(() => setResult(null), 5000);
  }
}


  return (
    <div className="bg-secondary/50 p-8 rounded-2xl border border-white/10">
      <form onSubmit={handleSubmit} className="space-y-6">
        <input
          type="hidden"
          name="from_name"
          value="BornAI Contact Form"
        />
        <input
          type="hidden"
          name="subject"
          value="New Contact Form Submission from Website"
        />

        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <label className="text-sm font-medium text-white">
              First Name
            </label>
            <Input
              name="first_name"
              required
              placeholder="John"
              className="bg-background/50 border-white/10"
            />
          </div>

          <div className="space-y-2">
            <label className="text-sm font-medium text-white">
              Last Name
            </label>
            <Input
              name="last_name"
              required
              placeholder="Doe"
              className="bg-background/50 border-white/10"
            />
          </div>
        </div>

        <div className="space-y-2">
          <label className="text-sm font-medium text-white">
            Work Email
          </label>
          <Input
            name="email"
            type="email"
            required
            placeholder="john@company.com"
            className="bg-background/50 border-white/10"
          />
        </div>

        <div className="space-y-2">
          <label className="text-sm font-medium text-white">
            Message
          </label>
          <Textarea
            name="message"
            required
            placeholder="Tell us about your project..."
            className="min-h-[120px] bg-background/50 border-white/10"
          />
        </div>

        <Button
          type="submit"
          disabled={isSubmitting}
          className="w-full bg-primary text-white hover:bg-primary/90 flex items-center gap-2"
        >
          {isSubmitting ? "Sending..." : "Send Message"}
          <Send className="h-4 w-4" />
        </Button>

        {result && (
          <p className="text-center text-sm mt-4 p-2 rounded-md bg-green-500/10 text-green-400 border border-green-500/20">
            {result}
          </p>
        )}
      </form>
    </div>
  );
}
